import { State as AppState } from '@app/store/app-state';
import { CurrentStep } from '@core/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { portalStepperFeatureKey } from './reducer';
import { State } from './state';

const getCurrentStep = (state: State): CurrentStep => ({
  currentStepIndex: state.currentStepIndex,
  maxStepIndex: state.maxStepIndex,
});

export const portalStepperState = createFeatureSelector<AppState, State>(
  portalStepperFeatureKey,
);

export const selectCurrentStep = createSelector(
  portalStepperState,
  getCurrentStep,
);
